<template>
  <upload-material
    :file-name="upload.filename"
    v-model="upload.url"
    :loading="loading"
    @uploadFile="uploadMultiPage">
      <template v-if="!disabled" v-slot="scope">
        <!-- 重新上传照片 -->
        <div :class="['reupload', isNotPass ? 'bg-red' : '']" v-if="!isPass">
          <label class="reupload-item" :for="scope.uploadInputId">重新上传</label>
        </div>

        <!-- 删除 非重新上传或者未支付，有图片-->
        <div class="delete" @click="doDeleteFile" v-if="firstUpload">
          <img src="../../../../../../assets/imgs/upload/delete.png">
          <span>删除</span>
        </div>

        <!-- 合格 一定要上传了图片才盖章 -->
        <div class="verify-passed verify-cover" v-if="isPass" @click="preview(upload.url)">
          <img src="../../../../../../assets/imgs/upload/pass.png" class="cover-img">
        </div>

        <!-- 不合格 一定要上传了图片才盖章 -->
        <div class="verify-not-pass verify-cover" v-if="isNotPass" @click="preview(upload.url)">
          <img src="../../../../../../assets/imgs/upload/not-pass.png" class="cover-img">
        </div>
      </template>
  </upload-material>
</template>


<script>
import utils from '@/libs/utils';
import Http from '@/libs/http';
import UploadMaterial from './upload-material.vue';
import uploadFileService from '@/services/upload-file-service';

export default {
  components: {
    UploadMaterial,
  },
  props: {
    // 当前对象
    upload: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 判断是否为第一次新增的情况，如果是则不走请求，点击提交时候直接上传
    firstUpload: {
      type: Boolean,
      default: true,
    },
    // 当前编辑图片的申请人id
    applicantId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    // 审核不通过
    isNotPass() {
      return this.upload && this.upload.status === 2;
    },
    // 审核通过
    isPass() {
      return this.upload && this.upload.status === 1;
    },
  },
  methods: {
    // 上传函数
    getUploadMultiParams(files) {
      // 在这里可以根据url判断是不是文件替换
      const promiseStack = files.map(file => uploadFileService.uploadFileWithOssout(file, false, { noKey: true }).then((res) => {
        const currentId = this.upload.id;
        const url = `https://${res.oss_out}/${res.key}`;
        
        // 第一次请求前端处理  
        if (this.firstUpload) { 
          const imgItem = {
            url,
            key: res.key,
            id: currentId,
          };
          return Promise.resolve(imgItem);
        } 

        // 非第一次上传需要发送请求
        const params = {
          key: res.key,
          applicant_id: this.applicantId || undefined,
          id: currentId,
        };
        return Http.post('/reject_product_applicant_file_replace', params).then(() => ({ 
          url,
          id: currentId,
        }));
      }).catch((e) => {
        if (e) console.log(e);
      }));

      return Promise.all(promiseStack);
    },

    // 上传资料
    async uploadMultiPage(files) {
      this.loading = true;
      
      // 图片上传
      this.getUploadMultiParams(files).then((imgUrlList) => {
        console.log('编辑文件上传时候的数据为=======', imgUrlList);
        const uploadImgList = imgUrlList.map((img, imgIndex) => {
          const dowloadName = files[imgIndex] && files[imgIndex].name;
          img.filename = dowloadName;
          return img;
        });
        this.$emit('replaceItem', uploadImgList[0]);
      }).catch((e) => {
        if (e) console.log(e);
      }).finally(() => {
        this.loading = false;
      });
    },

    // 删除
    doDeleteFile() {
      if (!this.upload) return;
      utils.msgbox.confirm(`确定要删除该${
        this.upload.url && this.upload.url.indexOf('.pdf') ? '文件' : '图片'
      }吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$emit('deleteItem', this.upload);
        utils.msg.success('删除成功!');
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 图片预览
    preview(url) {
      if (!url) return; 
      this.$viewerApi({
        images: [url],
      });
    },

  },


};
</script>


// WEBPACK FOOTER //
// src/pages/orders/reject-product-applicant/components/upload-reject-material-list/components/update-upload-material.vue